import styled from "styled-components";
import media from "styled-media-query";
import customMedia from "../../../../config/breakpoints";

export const TitleContainer = styled.div`
  width: 70%;
  span {
    text-decoration: underline;
  }

  ${media.lessThan("medium")`
    width: 100%;
  `}
`;
export const SubTitleContainer = styled.div`
  margin-top: 24px;
  width: 100%;

  ${customMedia.greaterThan("desktop")`
    width: 70%;
  `}
`;

export const OrientationContainer = styled.div`
  margin: 80px 0 40px 0;
  width: 100%;
`;
